// Public, React/Redux-free widget catalog. External templates retain layout ownership.
import mobileDefinitions from './mobile.json';
import { isRetailMediaTemplate } from './shared';
export { CMS_IMPRESSION_VIEWS } from './cms';
export { storeTemplate, storeViewIds } from './store';
export { retailViews } from './retail';
export { webWidgets } from './web';

export const mobileWidgets = Object.fromEntries(mobileDefinitions.map(definition => [definition.id, definition]));

export const isMobileViewTemplate = template => !template?.isCms &&
  (template?.headers === 'mobile' || isRetailMediaTemplate(template));

// Original KPI cards are excluded from the Mobile/Retail grid.
// mobile-signals is retained as the daily Foot Traffic chart.
export const legacyMobileKpiIds = ['mobile-impressions', 'mobile-frequency', 'mobile-reach'];
export const campaignWidgets = ['impressions', 'frequency', 'reach'].map(metric => ({
  ...mobileWidgets[`mobile-${metric}`],
  id: `campaign-${metric}`,
  title: `Campaign ${metric[0].toUpperCase()}${metric.slice(1)}`,
  campaignMetric: true
}));

export const withCampaignWidgets = (rows = [], template) => {
  if (!isMobileViewTemplate(template)) return rows;
  let visibleRows = rows.map(row => row.filter(widget => {
    if (campaignWidgets.some(item => item.id === widget?.id)) return true;
    const filename = (widget?.widgetUrl || widget?.url || '').split('?')[0].split('/').pop().toLowerCase();
    return !legacyMobileKpiIds.some(id => id === widget?.id ||
      mobileWidgets[id].filename.toLowerCase() === filename ||
      (widget?.query?.type === 'mobile' && widget.query.dimension === mobileWidgets[id].legacyDimension));
  })).filter(row => row.length);
  const retailLayout = [template.id, template.name, template.displayName]
    .some(value => String(value || '').replace(/[^a-z0-9]/gi, '').toLowerCase().includes('retailmedia'));
  if (retailLayout) {
    const isFootTraffic = widget => getMobileWidgetDefinition(widget, template)?.viewId === 'mobile_footfall_over_time';
    const footTraffic = visibleRows.flat().filter(isFootTraffic);
    if (footTraffic.length) {
      visibleRows = visibleRows.map(row => row.filter(widget => !isFootTraffic(widget))).filter(row => row.length);
      const position = visibleRows[0]?.some(widget => !widget?.cmsImpressions && !widget?.campaignMetric) ? 1 : 0;
      visibleRows.splice(position, 0, footTraffic);
    }
  }
  const existingIds = new Set(visibleRows.flat().map(widget => widget?.id));
  const missing = campaignWidgets.filter(widget => !existingIds.has(widget.id));
  if (!missing.length) return visibleRows;
  const firstCmsRow = visibleRows.findIndex(row => row.some(widget => widget?.cmsImpressions));
  const position = firstCmsRow < 0 ? visibleRows.length : firstCmsRow;
  return [...visibleRows.slice(0, position), missing, ...visibleRows.slice(position)];
};

export const getMobileWidgetDefinition = (widget, template) => {
  if (!isMobileViewTemplate(template)) return null;
  const campaignDefinition = campaignWidgets.find(item => item.id === widget?.id);
  if (campaignDefinition) return campaignDefinition;
  const filename = (widget?.widgetUrl || widget?.url || '').split('?')[0].split('/').pop().toLowerCase();
  const definition = mobileWidgets[widget?.id] || mobileDefinitions.find(item => item.filename.toLowerCase() === filename) ||
    (widget?.query?.type === 'mobile' ? mobileDefinitions.find(item => item.legacyDimension === widget.query.dimension) : null);
  if (legacyMobileKpiIds.includes(definition?.id)) return null;
  return definition ? { ...definition, id: widget.id || definition.id } : null;
};
export { buildMobileRequest, adaptMobileResponse } from './mobile';
export { getCampaignOptions } from './campaigns';
export { buildCmsImpressionsRequest, getCmsImpressionsTableData } from './cmsRuntime';
export { buildFunnelRequest, parseFunnelData } from './funnel';
